import { Expose } from "class-transformer";

import { BaseModel } from "src/shared/models/base.model";

export class DocumentsTreeNoDeclaredStuff extends BaseModel {
    @Expose() label = "";
    @Expose() name = "";
    @Expose() value = false;
}
